import { render, staticRenderFns } from "./AnnualReturns.vue?vue&type=template&id=e0dd7a4a&"
import script from "./AnnualReturns.vue?vue&type=script&lang=js&"
export * from "./AnnualReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports